module.exports = __webpack_public_path__ + "img/mes-invite-bg.2c190402.png";